import { DECISION_REASON_MAX, DECISION_RESULT } from '../../../core/constants/domain';

// Strip control characters pasted from PDFs or terminals (vite/05 client sanitizing).
// eslint-disable-next-line no-control-regex
const CONTROL_CHARS = /[\u0000-\u0008\u000B\u000C\u000E-\u001F\u007F]/g;

export function cleanReason(raw) {
    return String(raw ?? '').replace(CONTROL_CHARS, '').trim();
}

export function validateDecision({ result, reason }) {
    const errors = {};
    const cleaned = cleanReason(reason);
    if (result !== DECISION_RESULT.APPROVED && result !== DECISION_RESULT.RETURNED) {
        errors.result = 'Elige aceptar o devolver.';
    }
    if (result === DECISION_RESULT.RETURNED && !cleaned) {
        errors.reason = 'Explica qué debe corregirse para devolver la entrega.';
    }
    if (cleaned.length > DECISION_REASON_MAX) {
        errors.reason = `El motivo no puede superar ${DECISION_REASON_MAX} caracteres.`;
    }
    return { isValid: Object.keys(errors).length === 0, errors, reason: cleaned };
}

export function describeDecisionError(error) {
    if (!error) return null;
    if (error.status === 409) return 'La ronda cambió mientras decidías (otra persona decidió o hubo una nueva entrega). Recarga la revisión.';
    if (error.status === 403 && error.gate === 'qa') return 'Necesitas rol QA o lead en un equipo del proyecto para decidir.';
    if (error.status === 403 && error.gate === 'sesion_humana') return 'Esta decisión exige una sesión humana.';
    if (error.status === 403) return 'No tienes permiso para decidir esta revisión.';
    if (error.status === 422 && error.gate === 'version') return 'La ronda no está versionada; no se puede aprobar.';
    if (error.status === 429) return 'Demasiadas solicitudes seguidas. Espera unos segundos.';
    return error.message || 'No se pudo registrar la decisión.';
}
